import Markdown from "react-markdown";

interface MarkdownRendererProps {
  children: string;
  className?: string;
}

export function MarkdownRenderer({
  children,
  className = "",
}: MarkdownRendererProps) {
  return (
    <div
      className={`markdown-preview text-sm ${className} text-gray-700 dark:text-gray-200`}
      style={{
        fontSize: "14px",
        lineHeight: "1.6",
        maxWidth: "100%",
        overflowWrap: "break-word",
        wordBreak: "break-word",
      }}
    >
      <Markdown
        components={{
          h1: ({ children }) => (
            <h1
              style={{
                fontSize: "1.5em",
                fontWeight: "bold",
                margin: "1em 0 0.5em 0",
              }}
            >
              {children}
            </h1>
          ),
          h2: ({ children }) => (
            <h2
              style={{
                fontSize: "1.3em",
                fontWeight: "bold",
                margin: "0.8em 0 0.4em 0",
              }}
            >
              {children}
            </h2>
          ),
          h3: ({ children }) => (
            <h3
              style={{
                fontSize: "1.1em",
                fontWeight: "bold",
                margin: "0.6em 0 0.3em 0",
              }}
            >
              {children}
            </h3>
          ),
          p: ({ children }) => (
            <p
              style={{
                margin: "0.5em 0",
                overflowWrap: "break-word",
                wordBreak: "break-word",
              }}
            >
              {children}
            </p>
          ),
          strong: ({ children }) => (
            <strong
              style={{
                fontWeight: "bold",
              }}
            >
              {children}
            </strong>
          ),
          em: ({ children }) => (
            <em
              style={{
                fontStyle: "italic",
              }}
            >
              {children}
            </em>
          ),
          ul: ({ children }) => (
            <ul
              style={{
                margin: "0.5em 0",
                paddingLeft: "1.5em",
                listStyleType: "disc",
                listStylePosition: "outside",
              }}
            >
              {children}
            </ul>
          ),
          ol: ({ children }) => (
            <ol
              style={{
                margin: "0.5em 0",
                paddingLeft: "1.5em",
                listStyleType: "decimal",
                listStylePosition: "outside",
              }}
            >
              {children}
            </ol>
          ),
          li: ({ children }) => (
            <li style={{ margin: "0.2em 0", display: "list-item" }}>
              {children}
            </li>
          ),
          code: ({ children }) => (
            <code
              style={{
                padding: "0.125em 0.25em",
                borderRadius: "0.25em",
                fontFamily:
                  'ui-monospace, SFMono-Regular, "SF Mono", Monaco, Consolas, "Liberation Mono", "Courier New", monospace',
                fontSize: "0.875em",
                overflowWrap: "break-word",
                wordBreak: "break-all",
              }}
            >
              {children}
            </code>
          ),
          pre: ({ children }) => (
            <pre
              style={{
                padding: "1em",
                borderRadius: "0.5em",
                overflowX: "auto",
                margin: "0.5em 0",
                fontFamily:
                  'ui-monospace, SFMono-Regular, "SF Mono", Monaco, Consolas, "Liberation Mono", "Courier New", monospace',
                maxWidth: "100%",
                whiteSpace: "pre-wrap",
                overflowWrap: "break-word",
              }}
            >
              {children}
            </pre>
          ),
          blockquote: ({ children }) => (
            <blockquote
              style={{
                borderLeft: "4px solid #E5E7EB",
                paddingLeft: "1em",
                margin: "0.5em 0",
                fontStyle: "italic",
              }}
            >
              {children}
            </blockquote>
          ),
          hr: () => (
            <hr
              style={{
                border: "none",
                borderTop: "1px solid #E5E7EB",
                margin: "1em 0",
              }}
            />
          ),
        }}
      >
        {children}
      </Markdown>
    </div>
  );
}
